import { Action, createAction } from 'typesafe-actions'

export const addPendingRequest = createAction('DOC / PendingRequest / add')<string, { causedBy: Action }>()

export const removePendingRequest = createAction('DOC / PendingRequest / remove')<string, { causedBy: Action }>()
